import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const sections = [
  { to: '/admin', label: 'Настройки и шаблоны' },
  { to: '/admin-generations', label: 'Все сайты' },
  { to: '/admin/generator', label: 'Тестовая генерация' },
  { to: '/admin/component-tester', label: 'Тест компонентов' },
  { to: '/admin/background-tester', label: 'Тест фонов' },
  { to: '/admin/services', label: 'Провайдеры Whitepage' },
];

export default function AdminNavigation() {
  const location = useLocation();
  return (
    <nav aria-label="Инструменты администратора" className="u2-card" style={{ marginBottom: 18 }}>
      <div className="u2-cardInner" style={{ padding: 16 }}>
        <div className="u2-strong" style={{ marginBottom: 10 }}>Админ-панель</div>
        <div className="u2-row" style={{ flexWrap: 'wrap', gap: 8 }}>
          {sections.map(section => <NavLink
            key={section.to}
            to={section.to}
            end
            className={`u2-btn ${location.pathname === section.to ? 'is-success' : 'is-secondary'}`}
          >{section.label}</NavLink>)}
        </div>
      </div>
    </nav>
  );
}
